import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg } from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Enum from 'services/enum2';
function SaleDeliveryReturnDetail(props) {
  const Config = {
    sale: {
      apiPath: '/customerReturnOrder/detail',
      enumMainKey: 'B02_Rto_Status',
      companyNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Is_Contain_Tax',
          subKey: 'isContainTax',
          value: 'isContainTaxName'
        },
        {
          mainKey: 'B02_ReturnOrder_Type',
          subKey: 'returnType',
          value: 'returnTypeName'
        },
        {
          mainKey: 'B02_Rto_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'rtoXkNo'
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    redirect,
    decimalPlace,
    forceUpdate,
    detail,
    setDetail,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);
  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  self.afterGetDetail = function (data) {
    let list = data.lineList || [];
    list.forEach(item => {
      Enum.getValue('B02_Boolean_Result', item.isExchangeFlag).then(value => {
        item.isExchangeFlagName = value;
        forceUpdate();
      });
    });
    data.taxRate = data.taxRate * 100;
    setDetail(data);
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">客户</span>
                  <div className="field-value">{detail.innerCustomerName}</div>
                </li>
                <li>
                  <span className="field-label">退货单号</span>
                  <div className="field-value">{detail.rtoErpNo}</div>
                </li>
                <li>
                  <span className="field-label">退货日期</span>
                  <div className="field-value">
                    {formatDate(detail.erpReturnDate)}
                  </div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">{detail.statusName}</div>
                </li>
                <li>
                  <span className="field-label">退货类型</span>
                  <div className="field-value red">{detail.returnTypeName}</div>
                </li>
                <li>
                  <span className="field-label">是否换货</span>
                  <div className="field-value">
                    {detail.isExchangeProd === 1 ? '是' : '否'}
                  </div>
                </li>
                <li>
                  <span className="field-label">是否折让退货</span>
                  <div className="field-value">
                    {detail.isDiscountReturn === 1 ? '是' : '否'}
                  </div>
                </li>
                <li>
                  <span className="field-label">交易条件</span>
                  <div className="field-value">{detail.conditionName}</div>
                </li>
                <li>
                  <span className="field-label">币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">交易税别</span>
                  <div className="field-value">
                    {detail.taxName}
                    {detail.taxName && ','}
                    {detail.isContainTaxName}
                    {detail.isContainTaxName && (
                      <span>, 税率{detail.taxRate}%</span>
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">付款条件</span>
                  <div className="field-value">
                    <div>
                      {detail.payWayCode}-{detail.payWayName}
                    </div>
                  </div>
                </li>
                <li>
                  <span className="field-label">备注</span>
                  <div className="field-value">{detail.dnXkNo}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>退货明细</label>
          </div>
          <div className="details-item-content">
            {!Util.isEmpty(detail.lineList) &&
              detail.lineList?.map((line, index) => (
                <div
                  className="content-line line-list-item"
                  key={String(line.id) + index}
                >
                  <div className="line-list-item-title">
                    <span>序号{index + 1}</span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{line.productCode}</div>
                    </li>
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{line.productName}</div>
                    </li>
                    <li>
                      <span className="field-label">产品规格</span>
                      <div className="field-value">{line.productScale}</div>
                    </li>
                    <li>
                      <span className="field-label">制造商料号</span>
                      <div className="field-value">
                        {line.manufacturerProdCode}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">品牌</span>
                      <div className="field-value">{line.brandName}</div>
                    </li>
                    {line.poLine && line.poLine.printExtendFields !== '' && (
                      <li>
                        <span className="field-label">采购说明</span>
                        <div className="field-value">
                          {line.poLine.printExtendFields}
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">采购单号(项次)</span>
                      <div className="field-value">
                        {line.poErpNo}({line.poLineNoShow || line.poLineNo})
                      </div>
                    </li>
                    <li>
                      <span className="field-label">退货单位</span>
                      <div className="field-value">{line.returnUnitName}</div>
                    </li>
                    <li>
                      <span className="field-label">计价单位</span>
                      <div className="field-value">
                        {line.valuationUnitName}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">退货数量</span>
                      <div className="field-value">
                        {formatNumber(
                          line.returnQty,
                          decimalPlace.Quantity_Decimal_Place
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">计价数量</span>
                      <div className="field-value">
                        {formatNumber(
                          line.returnValuationQty,
                          decimalPlace.Quantity_Decimal_Place
                        )}
                      </div>
                    </li>

                    {detail.returnType === 2 && (
                      <li>
                        <span className="field-label">是否换货</span>
                        <div className="field-value">
                          {line.isExchangeFlagName}
                        </div>
                      </li>
                    )}

                    <li>
                      <span className="field-label">单价</span>
                      <div className="field-value">
                        {formatNumber(
                          line.isContainTax ? line.taxPrice : line.price,
                          decimalPlace.PRICE
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">金额</span>
                      <div className="field-value">
                        {formatNumber(
                          line.isContainTax
                            ? line.taxLineAmount
                            : line.lineAmount,
                          decimalPlace.AMOUNT
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">是否对账</span>
                      <div className="field-value">
                        {line.isStatement === '1' ? '是' : '否'}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">备注</span>
                      <div className="field-value">{line.remark}</div>
                    </li>
                  </ul>
                </div>
              ))}
          </div>
        </div>
      </div>
      <Modal></Modal>
    </div>
  );
}

SaleDeliveryReturnDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SaleDeliveryReturnDetail);
